<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <SolicitacaoHistorico
      :funcionalidade="funcionalidade"
      :rota-detalhe="rotaDetalhe"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoHistorico from '@/components/TemplateSolicitacao/SolicitacaoHistorico'

export default {
  name: 'Func16Historico',
  components: {
    SolicitacaoHistorico,
    FuncionalidadeHeader
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  },
  methods: {
    async init () {
    }
  },
  mounted () {
    this.init()
  }
}
</script>
